module.exports = __webpack_public_path__ + "static/media/20x16.ceb7b8e5.png";